/** useTabBlur
 * This composable provides methods to handle focus and blur events for tabs.
 * It changes the document title when the tab is blurred and restores it when focused.
 * It also cycles through a set of messages to indicate that the tab is abandoned.
 */

export function useTabBlur() {
    const { t } = useI18n();

    return {
        // Changes the document title when the window loses focus
        handleBlur: () => {
            const siteTitle = document.title;

            // We have 4 alternating messages, so this goes through 8 numbers (see below) to show either a message or the original site title.
            let index = 0;

            const interval = setInterval(() => {
                if (index % 2 === 1) {
                    document.title = siteTitle;
                } else {
                    const messageIndex = index / 2;
                    document.title = t(`abandoned-tab.return-${messageIndex + 1}`);
                }

                index += 1;
                index %= 8;
            }, 5000);

            // Clear the interval when focus is regained
            window.addEventListener('focus', () => {
                clearInterval(interval);

                document.title = siteTitle;
            }, { once: true });
        },
    };
}
